// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58cdc5cb","455":"860678be","977":"a7fc065e"}[chunkId] + ".chunk.js";
};